import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type freeChooseYourEditionModalQuery,
} from './__generated__/freeChooseYourEditionModalQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	hamsProductKey: string;
};

export const entryPoint: EntryPoint<
	EntryPointComponent<
		{
			freeChooseYourEditionModalQuery: freeChooseYourEditionModalQuery;
		},
		Record<string, never>,
		{
			onClose: (extraInformation?: unknown) => void;
		},
		Record<string, never>
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-free-choose-your-edition-modal" */ './free-choose-your-edition-modal'
			),
		{
			moduleId: 'edition-awareness-free-choose-your-edition-modal',
		},
	),
	getPreloadProps: ({ cloudId, hamsProductKey }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			freeChooseYourEditionModalQuery: {
				parameters,
				variables: {
					cloudId,
					hamsProductKey,
				},
			},
		},
	}),
});
